import React, { Component } from "react";
import { connect } from "react-redux";
import { getOppositeStretch, stretchTranslation } from "../shared/utils";
import R from "ramda";
import { setFilter } from "../actions";

class AlertsWrapper extends Component {
	constructor() {
		super();
		this.alert = false;
	}

	getOppositeFlight() {
		const selectedFlights = this.props.selectedFlights,
			currentStretch = this.props.currentStretch,
			oppositeStretch = getOppositeStretch(currentStretch),
			oppositeFlight = selectedFlights[oppositeStretch];

		return oppositeFlight;
	}

	selectedCompany() {
		if (this.getOppositeFlight().length > 0) return this.getOppositeFlight();
	}

	render() {
		const currentStretch = this.props.currentStretch;
		const selectedFlights = this.props.selectedFlights;

		const flightOnOppositeStretch = selectedFlights[getOppositeStretch(currentStretch)];

		const filterOnCurrentStretch = this.props.selectedFilters[currentStretch].airlines;
		const currentStretchText = stretchTranslation[currentStretch].toUpperCase();

		if (flightOnOppositeStretch.length > 0 && this.props.isInternational === false) {
			const airlineFilter = filterOnCurrentStretch;

			let toggleSameDiffCias = null;

			if (!R.equals(airlineFilter, [flightOnOppositeStretch[0].airline])) {
				toggleSameDiffCias = "";
			} else {
				toggleSameDiffCias = (
					<span>
						Para ver <strong>VOOS DE {currentStretchText}</strong> das outras companhias,{" "}
						<a
							href=""
							onClick={e => {
								e.preventDefault();
								this.props.setFilter(
									{ airlines: flightOnOppositeStretch[0].airline },
									currentStretch
								);
							}}
							title="Clique para ver voos das outras companhias"
							className="alert-link"
						>
							<strong>clique aqui</strong>
						</a>.
					</span>
				);
			}

			return (
				<div className="alert alert-warning" role="alert">
					<div className="alert--icon">
						<i className="icon-pin" />
					</div>
					<div className="alert--message">
						<p>
							Mais vantagem e comodidade para você! Agora você pode comprar voos de ida e volta de
							cias diferentes, uma exclusividade MaxMilhas. {toggleSameDiffCias}
						</p>
					</div>
				</div>
			);
		}

		return null;
	}
}

const mapStateToProps = state => ({
	selectedFlights: state.selectedFlights,
	currentStretch: state.flightsTab.currentStretch,
	selectedFilters: state.selectedFilters,
	isInternational: state.searchStatus.isInternational
});
const mapDispatchToProps = dispatch => ({
	setFilter: (filter, stretch) => {
		dispatch(setFilter(filter, stretch));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertsWrapper);
